package cc.bluepeak.clubmanager.site.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import cc.bluepeak.clubmanager.site.Res
import cc.bluepeak.clubmanager.site.components.layouts.PageLayoutData
import cc.bluepeak.clubmanager.site.components.sections.ContactSection
import cc.bluepeak.clubmanager.site.components.sections.FeatureCard
import cc.bluepeak.clubmanager.site.components.sections.FeatureImageCard
import cc.bluepeak.clubmanager.site.components.widgets.Checkmark
import cc.bluepeak.clubmanager.site.components.widgets.FieldTag
import cc.bluepeak.clubmanager.site.components.widgets.LineTag
import cc.bluepeak.clubmanager.site.styles.ButtonLinkVariant
import cc.bluepeak.clubmanager.site.styles.CardStyle
import cc.bluepeak.clubmanager.site.styles.PaddedCardStyle
import cc.bluepeak.clubmanager.site.styles.SecondaryCardStyle
import cc.bluepeak.clubmanager.site.styles.Theme
import cc.bluepeak.clubmanager.site.styles.UnderlinedInputVariant
import cc.bluepeak.clubmanager.site.util.ScrollTrigger
import cc.bluepeak.clubmanager.site.util.gsap
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.alignSelf
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.gridColumn
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.isExporting
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.forms.Input
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.lucide.LucideBlocks
import com.varabyte.kobweb.silk.components.icons.lucide.LucideCloudOff
import com.varabyte.kobweb.silk.components.icons.lucide.LucideMonitorSmartphone
import com.varabyte.kobweb.silk.components.icons.lucide.LucideShieldCheck
import com.varabyte.kobweb.silk.components.icons.lucide.LucideSparkle
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.VerticalDivider
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.browser.document
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.plus
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.unaryMinus
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import kotlin.js.json

@InitRoute
fun initIndex(ctx: InitRouteContext) {
    ctx.data.add(PageLayoutData(Res.string.clubmanager, Res.string.hero_title))
}

val stickySectionStyle = CssStyle {
    base {
        Modifier
    }

    Breakpoint.SM {
        Modifier.alignSelf(AlignSelf.Start).position(Position.Sticky)
    }
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun Index() {
    val ctx = rememberPageContext()
    var horizontalDistance by mutableStateOf(0.0)
    DisposableEffect(Unit) {
        if (AppGlobals.isExporting) return@DisposableEffect onDispose {}
        val track =
            document.getElementById("horizontal-track") ?: return@DisposableEffect onDispose { println("Not found") }
        val wrapper =
            document.getElementById("horizontal-wrapper") ?: return@DisposableEffect onDispose { println("Not found") }
        val page = document.getElementById("page") ?: return@DisposableEffect onDispose { println("Not found") }
        horizontalDistance = track.getBoundingClientRect().right - wrapper.getBoundingClientRect().right + 30
        ScrollTrigger.enable()
        val trigger = gsap.to(
            track, json(
                "x" to -horizontalDistance,
                "ease" to "none",
                "scrollTrigger" to json(
                    "trigger" to track,
                    "start" to "top-=120 top",
                    "end" to "+=${horizontalDistance}",
                    "pin" to page,
                    "scrub" to true,
                    "invalidateOnRefresh" to true,
                )
            )
        )
        onDispose {
            ScrollTrigger.disable()
            trigger.kill()
        }
    }
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(2.cssRem)) {
        SimpleGrid(numColumns(1, md = 2), PaddedCardStyle.toModifier().fillMaxWidth().alignItems(AlignItems.Center)) {
            Column(
                verticalArrangement = Arrangement.Center,
                horizontalAlignment = Alignment.End,
                modifier = Modifier.fillMaxWidth()
            ) {
                Column(Modifier.maxWidth(500.px)) {
                    FieldTag(Res.string.hero_tag)
                    H1(Modifier.whiteSpace(WhiteSpace.BreakSpaces).toAttrs()) { Text(Res.string.hero_title) }
                    P(
                        Modifier.lineHeight(1.4).fontWeight(400).color(Theme.secondary)
                            .margin(top = 1.cssRem, bottom = 2.cssRem)
                            .toAttrs()
                    ) {
                        Text(Res.string.hero_desc)
                    }
                    SpanText(Res.string.hero_cta, Modifier.fontWeight(500))
                    Row(
                        verticalAlignment = Alignment.CenterVertically,
                        modifier = Modifier.flexWrap(FlexWrap.Wrap).gap(1.cssRem)
                    ) {
                        var email by remember { mutableStateOf("") }
                        Input(
                            InputType.Email,
                            email,
                            { email = it },
                            placeholder = Res.string.email_placeholder,
                            variant = UnderlinedInputVariant
                        )
                        Button(onClick = {
                            ctx.router.tryRoutingTo("${Res.link.register}?email=$email")
                        }) { Text(Res.string.get_started) }
                    }
                }
            }
            Image(Res.image.hero, Modifier.fillMaxWidth())
        }

        Row(
            Modifier.id("horizontal-wrapper").fillMaxWidth().borderRadius(Theme.shapes.medium).padding(2.cssRem)
                .backgroundImage(url("""/${Res.string.locale}/${Res.image.fabric1}"""))
                .background {
                    size(BackgroundSize.Cover)
                    position(BackgroundPosition.of(CSSPosition.Center))
                }
                .overflow(Overflow.Hidden)
        ) {
            Column {
                LineTag(Res.string.tech_tag, Modifier.color(Theme.white))
                H1(Modifier.whiteSpace(WhiteSpace.BreakSpaces).color(Theme.white).width(Width.MaxContent).toAttrs()) {
                    Text(Res.string.tech_title)
                }
            }
            Row(Modifier.id("horizontal-track").margin(left = 1.cssRem).gap(4.cssRem)) {
                FeatureCard(Res.string.tech_ai_title, Res.string.tech_ai_desc, 1, 5) {
                    LucideSparkle(size = 2.5.em, color = Theme.white, strokeWidth = 1)
                }
                FeatureCard(Res.string.tech_customisable_title, Res.string.tech_customisable_desc, 2, 5) {
                    LucideBlocks(size = 2.5.em, color = Theme.white, strokeWidth = 1)
                }
                FeatureCard(Res.string.tech_offline_title, Res.string.tech_offline_desc, 3, 5) {
                    LucideCloudOff(size = 2.5.em, color = Theme.white, strokeWidth = 1)
                }
                FeatureCard(Res.string.tech_apps_title, Res.string.tech_apps_desc, 4, 5) {
                    LucideMonitorSmartphone(size = 2.5.em, color = Theme.white, strokeWidth = 1)
                }
                FeatureCard(Res.string.tech_gdpr_title, Res.string.tech_gdpr_desc, 5, 5) {
                    LucideShieldCheck(size = 2.5.em, color = Theme.white, strokeWidth = 1)
                }
            }
        }

        SimpleGrid(numColumns(1, 3), PaddedCardStyle.toModifier().fillMaxWidth().gap(2.cssRem)) {
            Column(Modifier.gridColumn("span 2")) {
                LineTag(Res.string.features_check_tag, Modifier.color(Theme.secondary))
                H2(Modifier.margin(bottom = 2.cssRem).toAttrs()) {
                    Text(Res.string.features_check_title)
                }
                SimpleGrid(numColumns(1, 2, 3), Modifier.fillMaxWidth()) {

                    Column(Modifier.gap(2.px)) {
                        Checkmark(Res.string.features_check_calendar)
                        Checkmark(Res.string.features_check_games)
                        Checkmark(Res.string.features_check_trainings)
                        Checkmark(Res.string.features_check_members)
                        Checkmark(Res.string.features_check_teams)
                        Checkmark(Res.string.features_check_pdfs)
                    }
                    Column(Modifier.gap(2.px)) {
                        Checkmark(Res.string.features_check_coaches)
                        Checkmark(Res.string.features_check_functionaries)
                        Checkmark(Res.string.features_check_applications)
                        Checkmark(Res.string.features_check_documents)
                        Checkmark(Res.string.features_check_newsletters)
                        Checkmark(Res.string.features_check_surveys)
                    }
                    Column(Modifier.gap(2.px)) {
                        Checkmark(Res.string.features_check_fees)
                        Checkmark(Res.string.features_check_sponsors)
                        Checkmark(Res.string.features_check_payouts)
                        Checkmark(Res.string.features_check_invoices)
                        Checkmark(Res.string.features_check_budgeting)
                        Checkmark(Res.string.features_check_permissions)
                    }
                }
            }
            Row(horizontalArrangement = Arrangement.End, verticalAlignment = Alignment.CenterVertically) {
                VerticalDivider(Modifier.displayIfAtLeast(Breakpoint.MD))
                Column(horizontalAlignment = Alignment.Start, verticalArrangement = Arrangement.Center) {
                    SpanText(
                        Res.string.features_check_cta,
                        modifier = Modifier.margin(bottom = 2.cssRem).fontWeight(600)
                    )
                    Link(Res.link.contact, Res.string.get_in_touch, variant = ButtonLinkVariant)
                }
            }
        }

        SimpleGrid(
            numColumns(1, 1, 2),
            PaddedCardStyle.toModifier().id("features").fillMaxWidth().gap(2.cssRem)
        ) {
            Column(stickySectionStyle.toModifier().top(-horizontalDistance.px + 7.cssRem)) {
                Column {
                    FieldTag(Res.string.features_tag)
                    H1 {
                        Text(Res.string.features_title)
                    }
                    P(
                        Modifier.lineHeight(1.4).fontWeight(400).color(Theme.secondary)
                            .margin(top = 1.cssRem, bottom = 2.cssRem)
                            .toAttrs()
                    ) {
                        Text(Res.string.features_desc)
                    }
                    Link(Res.link.register, Res.string.features_cta, variant = ButtonLinkVariant)
                }
            }
            Column(verticalArrangement = Arrangement.spacedBy(2.cssRem)) {
                FeatureImageCard(
                    Res.string.features_squad_title,
                    Res.string.features_squad_desc,
                    1,
                    Res.image.squad,
                    link = Res.link.memberAdministration
                )
                FeatureImageCard(
                    Res.string.features_calendar_title,
                    Res.string.features_calendar_desc,
                    2,
                    Res.image.calendar,
                    link = Res.link.calendar
                )
                FeatureImageCard(
                    Res.string.features_club_title,
                    Res.string.features_club_desc,
                    3,
                    Res.image.club,
                )
                FeatureImageCard(
                    Res.string.features_finance_title,
                    Res.string.features_finance_desc,
                    4,
                    Res.image.finance,
                    link = Res.link.invoicing
                )
            }
        }

        Column(PaddedCardStyle.toModifier().fillMaxWidth(), horizontalAlignment = Alignment.CenterHorizontally) {
            FieldTag(Res.string.difference_tag)
            H1 {
                Text(Res.string.difference_title)
            }
            SimpleGrid(numColumns(1, 2), Modifier.gap(1.cssRem).margin(topBottom = 2.cssRem)) {
                Column(SecondaryCardStyle.toModifier().padding(1.cssRem)) {
                    Box(CardStyle.toModifier().fillMaxWidth().padding(1.cssRem), contentAlignment = Alignment.Center) {
                        SpanText(Res.string.difference_other_title, Modifier.fontWeight(600).fontSize(1.2.cssRem))
                    }
                    Column(Modifier.gap(1.cssRem).padding(topBottom = 2.cssRem, leftRight = 1.cssRem)) {
                        Checkmark(Res.string.difference_other_browser, Theme.secondary)
                        Checkmark(Res.string.difference_other_generic, Theme.secondary)
                        Checkmark(Res.string.difference_other_fixed, Theme.secondary)
                        Checkmark(Res.string.difference_other_manual, Theme.secondary)
                        Checkmark(Res.string.difference_other_separate, Theme.secondary)
                    }
                }
                Column(SecondaryCardStyle.toModifier().padding(1.cssRem)) {
                    Row(
                        CardStyle.toModifier().fillMaxWidth().padding(1.cssRem).gap(1.cssRem),
                        horizontalArrangement = Arrangement.Center
                    ) {
                        Image(Res.image.logo, Modifier.height(1.8.cssRem))
                        SpanText(Res.string.clubmanager, Modifier.fontWeight(600).fontSize(1.2.cssRem))
                    }
                    Column(Modifier.gap(1.cssRem).padding(topBottom = 2.cssRem, 1.cssRem)) {
                        Checkmark(Res.string.difference_cm_apps)
                        Checkmark(Res.string.difference_cm_football)
                        Checkmark(Res.string.difference_cm_customisable)
                        Checkmark(Res.string.difference_cm_ai)
                        Checkmark(Res.string.difference_cm_platform)
                    }
                }
            }
            Link(Res.link.register, Res.string.get_started, variant = ButtonLinkVariant)
        }
        ContactSection()
    }
}